/**
 * NumberInput Component
 *
 * Numeric input for number field filters.
 * Used for operators: EQUAL, NOT_EQUAL, GT, GE, LT, LE
 */

import { InputNumber } from 'antd'

interface NumberInputProps {
  value?: number
  onChange: (value: number | null) => void
  placeholder?: string
}

export function NumberInput({ value, onChange, placeholder }: NumberInputProps) {
  return (
    <InputNumber
      value={value ?? null}
      onChange={onChange}
      placeholder={placeholder || 'Enter number'}
      style={{ width: '100%' }}
      controls={false}
      precision={2}
    />
  )
}
